import React from "react";
import { Navigate } from "react-router-dom";

// This component no longer needs 'allowedRoles'
const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");

    console.log("🔍 Checking Access → Token:", token);

    if (!token) {
        console.log("❌ No token found → Redirecting to /login");
        return <Navigate to="/login" replace />;
    }

    console.log("✅ Token Found → Access Granted");
    return children;
};

export default ProtectedRoute;